/* eslint-disable */
import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DeleteForeverOutlined, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import PageHeader from '../../components/PageHeader';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import {
    loadClasificacionMovimientos,
    saveClasificacionMovimiento,
} from '../../redux/ducks/clasificacionMovimientos';
import ClasificacionMovimientosForm from './ClasificacionMovimientosForm';
import ConfirmDialog from '../../components/ConfirmDialog';
import http from '../../http-common';
import { filterOnAnyField } from '../../utils';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
}));

const headCells = [
    { id: 'clasificacion', label: 'Clasificación' },
    { id: 'actions', label: 'Acciones', disableSorting: true },
];

export default function ClasificacionMovimientos() {
    const [openPopup, setOpenPopup] = useState(false);
    const classes = useStyles();
    const [filterFn, setFilterFn] = useState({ fn: (items) => items });
    const [recordForEdit, setRecordForEdit] = useState();
    const [filter, setFilter] = useState('');

    const dispatch = useDispatch();
    const clasificaciones = useSelector(
        (state) => state.clasificacionMovimientos.clasificaciones,
    );

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(clasificaciones, headCells, filterFn);

    useEffect(() => {
        dispatch(loadClasificacionMovimientos());
    }, [dispatch]);

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);
        setFilterFn({
            fn: (items) => {
                if (target.value === '') return items;
                return filterOnAnyField(items, target.value.toLowerCase());
            },
        });
    };

    const addOrEdit = (clasificacion, resetForm) => {
        dispatch(saveClasificacionMovimiento(clasificacion));
        setOpenPopup(false);
        resetForm();
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopup(true);
    };

    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });

    const deleteClasificacion = (item) => {
        setConfirmDialog({
            subtitle: '',
            title: '¿Desea borrar la clasificación?',
            isOpen: true,
            onConfirm: async () => {
                await http.delete(`/clasificacion-movimientos-bancarios/${item.id}`);
                dispatch(loadClasificacionMovimientos());
                setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
            },
        });
    };

    return (
        <>
            <PageHeader
                icon={<CategoryOutlinedIcon fontSize='large' />}
                subtitle=''
                title='Clasificación de Movimientos'
            />
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        onClick={() => dispatch(loadClasificacionMovimientos())}
                        startIcon={<RefreshIcon />}
                        text='Refrescar'
                        variant='outlined'
                    />
                    <Controls.Button
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopup(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nuevo'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.clasificacion}</TableCell>
                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => openInPopup(item)}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => deleteClasificacion(item)}
                                    >
                                        <DeleteForeverOutlined fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Clasificación de Movimiento'
            >
                <ClasificacionMovimientosForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                />
            </Popup>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </>
    );
}
